import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "../../actions/actions";
import { DetalhesFiltrosModel } from "../../../models/detalhesFiltrosModel";

export interface ConfiguracoesState {
  loading: boolean;
  menu: boolean;
  title: string;
  subTitle: string;
  //filtros avançados
  filtros: DetalhesFiltrosModel[];
  filtrosFormatado: DetalhesFiltrosModel[];
  //acesso
  paginaAcesso: string;
  //permissao
  idEmpresaPermissao: number;
}

const initialState: ConfiguracoesState = {
  loading: false,
  menu: false,
  title: "",
  subTitle: "",
  //filtros avançados
  filtros: [],
  filtrosFormatado: [],
  //acesso
  paginaAcesso: "login",
  //permissao
  idEmpresaPermissao: 0,
};

export const configuracoesSlice = createSlice({
  name: "configuracoes",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setMenu: (state, action) => {
      state.menu = action.payload;
    },
    setTitle: (state, action) => {
      state.title = action.payload;
    },
    setSubTitle: (state, action) => {
      state.subTitle = action.payload;
    },
    //filtros avançados
    adicionarFiltro: (state, action) => {
      state.filtros = [...state.filtros, action.payload];
    },
    removerFiltro: (state, action) => {
      state.filtros = state.filtros.filter((_, i) => i !== action.payload);
    },
    adicionarFiltroFormatado: (state, action) => {
      state.filtrosFormatado = [...state.filtrosFormatado, action.payload];
    },
    removerFiltroFormatado: (state, action) => {
      state.filtrosFormatado = state.filtrosFormatado.filter((_, i) => i !== action.payload);
    },
    //acesso
    setPaginaAcesso: (state, action) => {
      state.paginaAcesso = action.payload;
    },
    //permissao
    setIdEmpresaPermissao: (state, action) => {
      state.idEmpresaPermissao = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, (state) => {
      state.subTitle = "";
      state.filtros = [];
      state.filtrosFormatado = [];
    });
  },
});

export const {
  setLoading,
  setMenu,
  setTitle,
  setSubTitle,
  //filtros avançados
  adicionarFiltro,
  removerFiltro,
  adicionarFiltroFormatado,
  removerFiltroFormatado,
  //acesso
  setPaginaAcesso,
  //permissao
  setIdEmpresaPermissao,
} = configuracoesSlice.actions;

export default configuracoesSlice.reducer;
